/**
 * @desc 字典工具
 */
import fetch from './fetch';
import {typeQuery} from './util';

const isString = (value) => typeQuery(value) === typeQuery.string;
/**
 * @desc 字典数据集
 * @type {{}}
 */
export const dict = {};
/**
 * @desc 完整的字典数据集
 * @type {{}}
 */
export let dictAll = {};
/**
 * @desc 城市字典集
 */
let cityDict = [];
/**
 * 整理字典数据集数据
 * @param data 数据
 * @return {{}}
 */
export const sortData = (data) => {
  dictAll = data;
  Object.keys((key) => delete dict[key]);
  (data || []).forEach((d) => {
    let typeChunk = dict[d.type];
    if (!typeChunk) typeChunk = dict[d.type] = {};
    typeChunk[d.code] = d.name;
    if (d.isDefault) typeChunk.default = d.code;
  });
  return dict;
};
/**
 * 获取获取类型数据
 * @param type 类型
 * @return {*|{}}
 */
export const fastGet = (type) => (dict[type] || {});
/**
 * 获取类型数据
 * @param type 类型
 * @return {{code: string, name: *}[]}
 */
export const get = (type) => {
  const typeChunk = fastGet(type);
  return Object.keys(typeChunk)
      .filter((key)=>key!=='default')
      .map((code) => ({code, name: typeChunk[code]}))
      .sort((a, b) => a.code - b.code);
};
/**
 * 获取类型的完整数据
 * @param type 类型
 * @return {string[]}
 */
export const getAll = (type) => {
  const typeChunk = (dictAll || []).filter((key) => key.type === type);
  return typeChunk.sort((a, b) => a.code - b.code);
};
/**
 * 获取默认类型数据的code值
 * @param type 类型
 * @return {{code: string, name: *}[]}
 */
export const getDefault = (type) => {
  const typeChunk = fastGet(type);
  return typeChunk.default || '';
};
/**
 * 获取完整的默认类型数据对象
 * @param type 类型
 * @return {string[]}
 */
export const getDefaultFull = (type) => {
  const typeChunk = getAll(type);
  return typeChunk.filter((item) => {
    return item.isDefault === 1;
  });
};
/**
 * 格式化数据
 * @param sourceData 原始数据
 * @param filed 字段映射
 * @param isBaseArray 是否为基础数组
 * @return {any[]}
 */
export const format = (sourceData, filed, isBaseArray = false) => {
  const type = typeQuery(sourceData);
  if (type === 'array') {
    if (!isBaseArray) {
      (sourceData || []).forEach((d) =>
        Object.keys(filed).forEach((k) => {
          const typeChunk = dict[filed[k]];
          typeChunk && (d[`${k}Name`] = dict[filed[k]][d[k]]);
        }));
    } else {
      const typeChunk = fastGet(filed);
      sourceData = sourceData.map((i) => typeChunk[i]);
    }
  } else if (type === 'object') {
    Object.keys(filed).forEach((k) =>
      sourceData[`${k}Name`] = dict[filed[k]][sourceData[k]]);
  }
  return sourceData;
};
export const translation = (value, type, joiner = '/') => {
  if (!isString(value)) return value;
  const typeDict = get(type) || [];
  if (!joiner || !isString(joiner)) return (typeDict.find((item) => item.code + '' === value + '') || {}).name;
  const typeDictMap = typeDict.reduce((o, c) => {
    o[c.code] = c.name;
    return o;
  }, {});
  return value.split(',').map((code) => typeDictMap[code]).join(joiner);
};
/**
 * @desc 获取城市以外的字典
 * @returns {Promise}
 */
// export const getDictExceptCity = () => fetch('/org/dict/data/excptCity');
export const getDictExceptCity = () => fetch('/business-dict-api/dict').then(({data}) => Promise.resolve({
  data: data.map((item) => ({
    code: item.code,
    name: item.value,
    type: item.type,
    isDefault: item.isDefault,
    seqCode: item.seqCode,
    parentCode: item.parentCode,
    parentId: item.parentId,
    id: item.id,
  })),
}));
/**
 * @desc 获取城市字典
 * @return {Promise<any | *[]>|Promise<[]>}
 */
export const getDictCity = () => {
  if (cityDict && cityDict.length > 0) return Promise.resolve(cityDict);
  return fetch('/org/dict/data?type=city').then(({data}) => {
    cityDict = data || [];
    return Promise.resolve(cityDict);
  });
};
/**
 * @desc 虎丘经济字典
 * @return {Promise}
 */
export const getDictEconmy = () => fetch('/org/dict/data?type=economy');
/**
 * @desc 初始化入口
 * @return {Promise<{}>}
 */
export const init = () => getDictExceptCity().then(({data}) => sortData(data || []));
/**
 * @desc Vue安装入口
 * @param Vue
 */
export const install = (Vue) => {
  Vue.prototype.$dict = {
    sortData,
    fastGet,
    get,
    getAll,
    getDefault,
    getDefaultFull,
    format,
    getDictCity,
    getDictEconmy,
    translation,
  };
};
export default {
  init,
  install,
};
